import DEFAULTS from 'core/data-model/constants/defaults'
import * as productIHealthyUltraSelector from 'quick-quote/product-ihealthy-ultra/coverage-plan/selectors'
import { getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'

/**
 * createProductIHealthyUltraFunc
 * @param productCommonService {ReturnType<import('./product-common').createProductCommonService>}
 */
export function createProductIHealthyUltraService(productCommonService) {
  /**
   * getBasicPlanOptions - selector
   * @param _state
   */
  function getBasicPlanOptions(_state) {
    return DEFAULTS.DEFAULT_IHEALTHY_ULTRA_PRODUCT_LIST.filter(
      (p) => p.isShow === true && productCommonService.getDisplayProductFromCache(p.code)
    ).map((p) => ({
      value: p.code,
      text: productIHealthyUltraSelector.getBasicPlanOptionText(p),
    }))
  }

  function getSelectedDisplayProductCodeIHealthyUltra(state) {
    return getSelectedDisplayProductCode(state)
  }

  return {
    getBasicPlanOptions,
    getSelectedDisplayProductCodeIHealthyUltra,
  }
}
